<template>
  <v-data-table
    v-model="selected"
    :headers="headers"
    :items="rows"
    :single-select="singleSelect"
    item-key="uuid"
    show-select
    class="elevation-1"
    @click:row="click"
  >
<template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>

  </v-data-table>

</template>

<script>
import axios from '../lib/axios'
const log = console.log

export default {
    data() {
      return {
        singleSelect: false,
        config: {},
        selected: [],
        headers: [],
        rows : [],
      }
    },
    created() {
        this.loadConfig()
    },
    props: {
        profile : String
    },
    methods : {
        loadConfig() {
            let self = this
            let url = '/static/dt_'+self.profile+'.json'
            axios.get(url)
            .then(function(r){
                let d = r.data
                let data = d
                self.config = data
                self.headers = self.config.columns || []
                self.refresh()
            })
            .catch(function(e){
              log('ERROR','DataTable:loadConfig', 'Attempt failed', e);
            });
        },
        refresh() {
            var self = this
            if (!this.config.source) return
            axios.get(this.config.source)
            .then(function(r){
                let d = r.data
                if (d.status != "success") throw (d.message || "UNKOWN")
                self.rows = d.data
            })
            .catch(function(e){
              log('ERROR','DataTable:refresh', 'Attempt failed', e);
            });
        },
        click(r) {
            this.$emit('row-click',r)
            return false
        }
    }
}

</script>
<style scoped>
table {
    width: 100%;
}
td:nth-child(1) {
    min-width: 300px;
}
</style>
